export default "__VITE_ASSET__DsWPRFRi__"